import { useRequiredParams } from '@pba/react-router';
import { AppLayout } from 'layouts';
import { ProgramAbout } from 'features/programs';

const PageProgramAbout = () => {
  const { programId } = useRequiredParams<{ programId: string }>();

  return (
    <AppLayout>
      <ProgramAbout programId={programId} />
    </AppLayout>
  );
};

export default PageProgramAbout;
